var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredExpressionlessFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z",
    fill: "#FFB02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13C8 12.4477 8.44772 12 9 12H13C13.5523 12 14 12.4477 14 13C14 13.5523 13.5523 14 13 14H9C8.44772 14 8 13.5523 8 13Z",
    fill: "#402A32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13C18 12.4477 18.4477 12 19 12H23C23.5523 12 24 12.4477 24 13C24 13.5523 23.5523 14 23 14H19C18.4477 14 18 13.5523 18 13Z",
    fill: "#402A32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19C10.4477 19 10 19.4477 10 20C10 20.5523 10.4477 21 11 21H21C21.5523 21 22 20.5523 22 20C22 19.4477 21.5523 19 21 19H11Z",
    fill: "#402A32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredExpressionlessFace);
export default __webpack_public_path__ + "static/media/coloredExpressionlessFace.a715616d8c787cbf66fa9c5f6f7c566e.svg";
export { ForwardRef as ReactComponent };